// Generated by ReScript, PLEASE EDIT WITH CARE

import * as OrderEntityMapper from "../../entity-mapper/OrderEntityMapper.bs.js";
import * as OrderFareEntityMapper from "../../entity-mapper/OrderFareEntityMapper.bs.js";
import * as OrderLogsEntityMapper from "../../entity-mapper/OrderLogsEntityMapper.bs.js";
import * as OrderFareV2EntityMapper from "../../entity-mapper/OrderFareV2EntityMapper.bs.js";
import * as OrderTicketEntityMapper from "../../entity-mapper/OrderTicketEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as OrderCommentsEntityMapper from "../../entity-mapper/OrderCommentsEntityMapper.bs.js";
import * as OrderScheduleEntityMapper from "../../entity-mapper/OrderScheduleEntityMapper.bs.js";
import * as InstaMojoDetailsStateMapper from "../../../../../to-be-migrated/domain/mapper/InstaMojoDetailsStateMapper.bs.js";
import * as PartnerEarningsEntityMapper from "../../entity-mapper/PartnerEarningsEntityMapper.bs.js";
import * as AutoCreateTicketEntityMapper from "../../entity-mapper/AutoCreateTicketEntityMapper.bs.js";
import * as PartnerGoodwillBonusEntityMapper from "../../entity-mapper/PartnerGoodwillBonusEntityMapper.bs.js";

var execute = InstaMojoDetailsStateMapper.execute;

var InstaMojoRepoConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var InstaMojoResponseConverter = partial_arg(InstaMojoRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = OrderLogsEntityMapper.execute;

var OrderLogsRepoConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var OrderLogsJsonResponseConverter = partial_arg$1(OrderLogsRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = OrderTicketEntityMapper.execute;

var TicketsConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var TicketsResponseConverter = partial_arg$2(TicketsConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$3 = OrderEntityMapper.execute;

var OrderResponseConverterConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var OrderResponseConverter = partial_arg$3(OrderResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$4 = OrderScheduleEntityMapper.execute;

var OrderScheduleConverterConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var OrderScheduleConverter = partial_arg$4(OrderScheduleConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$5 = OrderCommentsEntityMapper.execute;

var OrderCommentsResponseConverterConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$Catalyst.ResponseConverter;

var OrderCommentsResponseConverter = partial_arg$5(OrderCommentsResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$6(data) {
  return data;
}

var CreateCommentResponseConverterConfig = {
  execute: execute$6
};

var partial_arg$6 = ResponseHandler$Catalyst.ResponseConverter;

var CreateCommentResponseConverter = partial_arg$6(CreateCommentResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$7 = OrderTicketEntityMapper.execute;

var OrderTicketsConfig = {
  execute: execute$7
};

var partial_arg$7 = ResponseHandler$Catalyst.ResponseConverter;

var OrderTicketsResponseConverter = partial_arg$7(OrderTicketsConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$8 = OrderFareEntityMapper.execute;

var OrderFareResponseConverterConfig = {
  execute: execute$8
};

var partial_arg$8 = ResponseHandler$Catalyst.ResponseConverter;

var OrderFareResponseConverter = partial_arg$8(OrderFareResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$9 = PartnerEarningsEntityMapper.execute;

var PartnerEarningsConfig = {
  execute: execute$9
};

var partial_arg$9 = ResponseHandler$Catalyst.ResponseConverter;

var PartnerEarningsResponseConverter = partial_arg$9(PartnerEarningsConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$10 = OrderFareV2EntityMapper.execute;

var OrderFareV2ResponseConverterConfig = {
  execute: execute$10
};

var partial_arg$10 = ResponseHandler$Catalyst.ResponseConverter;

var OrderFareV2ResponseConverter = partial_arg$10(OrderFareV2ResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$11 = PartnerGoodwillBonusEntityMapper.execute;

var PartnerGoodwillBonusConfig = {
  execute: execute$11
};

var partial_arg$11 = ResponseHandler$Catalyst.ResponseConverter;

var PartnerGoodwillDIscountConverter = partial_arg$11(PartnerGoodwillBonusConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$12 = AutoCreateTicketEntityMapper.execute;

var AutoCreateTicketResponseConverterConfig = {
  execute: execute$12
};

var partial_arg$12 = ResponseHandler$Catalyst.ResponseConverter;

var AutoCreateTicketJsonResponseConverter = partial_arg$12(AutoCreateTicketResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  InstaMojoRepoConfig ,
  InstaMojoResponseConverter ,
  OrderLogsRepoConfig ,
  OrderLogsJsonResponseConverter ,
  TicketsConfig ,
  TicketsResponseConverter ,
  OrderResponseConverterConfig ,
  OrderResponseConverter ,
  OrderScheduleConverterConfig ,
  OrderScheduleConverter ,
  OrderCommentsResponseConverterConfig ,
  OrderCommentsResponseConverter ,
  CreateCommentResponseConverterConfig ,
  CreateCommentResponseConverter ,
  OrderTicketsConfig ,
  OrderTicketsResponseConverter ,
  OrderFareResponseConverterConfig ,
  OrderFareResponseConverter ,
  PartnerEarningsConfig ,
  PartnerEarningsResponseConverter ,
  OrderFareV2ResponseConverterConfig ,
  OrderFareV2ResponseConverter ,
  PartnerGoodwillBonusConfig ,
  PartnerGoodwillDIscountConverter ,
  AutoCreateTicketResponseConverterConfig ,
  AutoCreateTicketJsonResponseConverter ,
  
}
/* InstaMojoResponseConverter Not a pure module */
